<template>
  <v-card>
    <v-form ref="form" @submit.prevent="validate">
      <v-card-title></v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Username"
                  placeholder="Username"
                  hide-details="auto"
                  outlined
                  v-model="user.username"
                  :rules="[v => !!v || 'Username harus diisi!']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="Nama Lengkap"
                  placeholder="Nama Lengkap"
                  hide-details="auto"
                  outlined
                  v-model="user.name"
                  :rules="[v => !!v || 'Nama Lengkap harus diisi!']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" type="submit" :loading="loadingButton">Simpan</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  props: ['user', 'setAlert'],
  data() {
    return {
      loadingButton: false,
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.submit()
      }
    },
    submit() {
      this.loadingButton = true
      const token = localStorage.getItem('token')
      axios
        .patch(
          `${process.env.VUE_APP_API_ENDPOINT}profile/update`,
          {
            username: this.user.username,
            name: this.user.name,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then(res => {
          this.loadingButton = false
          if (res.status == 200) {
            const data = res.data
            this.setAlert({
              status: true,
              success: data.success,
              message: data.message,
            })
            if (data.success) {
              let user = {
                name: data.data.name,
                role: data.data.role_name,
                status: data.data.status,
                username: data.data.username,
              }
              localStorage.setItem('user', JSON.stringify(user))
            }
          } else {
            this.setAlert({
              status: true,
              success: false,
              message: res.statusText,
            })
          }
        })
        .catch(err => {
          this.loadingButton = false
          const response = err.response
          const data = response.data
          this.setAlert({
            status: true,
            success: false,
            message: data.message,
          })
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
  },
}
</script>

<style>
</style>